import { Component } from '@angular/core';

@Component({ selector: 'app-file-management', templateUrl: './file-management.component.html', styleUrl: './file-management.component.css' })
export class FileManagementComponent {
  activeTab = 'list';

  fileList = [
    { id: 1, name: 'brand-promo-q4.mp4',    type: 'Video',  size: '124 MB', uploadedBy: 'John Smith',    date: 'Jun 10, 2026', status: 'active'   },
    { id: 2, name: 'lobby-banner.png',       type: 'Image',  size: '2.4 MB', uploadedBy: 'Sarah Johnson', date: 'Jun 08, 2026', status: 'active'   },
    { id: 3, name: 'welcome-slideshow.pptx', type: 'Slides', size: '18 MB',  uploadedBy: 'Mike Davis',    date: 'Jun 05, 2026', status: 'inactive' },
    { id: 4, name: 'product-launch.mp4',     type: 'Video',  size: '256 MB', uploadedBy: 'Emily Chen',    date: 'Jun 01, 2026', status: 'active'   },
    { id: 5, name: 'menu-board.png',         type: 'Image',  size: '4.1 MB', uploadedBy: 'Robert Lee',    date: 'May 28, 2026', status: 'active'   },
    { id: 6, name: 'event-promo.mp4',        type: 'Video',  size: '88 MB',  uploadedBy: 'Anna Park',     date: 'May 20, 2026', status: 'inactive' },
  ];

  fileGroups = [
    { id: 1, name: 'Marketing Assets',   count: 24, createdBy: 'John Smith',    date: 'Mar 01, 2026' },
    { id: 2, name: 'Lobby Content',      count: 12, createdBy: 'Sarah Johnson', date: 'Mar 15, 2026' },
    { id: 3, name: 'Seasonal Promos',    count:  8, createdBy: 'Mike Davis',    date: 'Apr 01, 2026' },
    { id: 4, name: 'Product Launches',   count: 16, createdBy: 'Emily Chen',    date: 'Apr 20, 2026' },
    { id: 5, name: 'Training Videos',    count:  6, createdBy: 'Robert Lee',    date: 'May 05, 2026' },
  ];
}
